import { css } from 'styled-components';
import { th } from '@pubsweet/ui-toolkit';

/* All styles regarding ProseMirror surface and elements */

const fontWriting = css`
  color: ${th('colorText')};
  font-family: ${th('fontWriting')};
  font-size: ${th('fontSizeBase')};
`;

export default css`
  .ProseMirror {
    ${fontWriting}

    .citation-mark {
      color: var(--primary-color, #1890ff);
      cursor: pointer;
      font-weight: 500;
      user-select: all; /* Make it easier to select/manipulate as a single unit */
    }

  }
`;
